import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import SectionTitle from 'components/common/general/SectionTitle';
import { ProposalExperience } from 'store/modules/initiate-quote/types';
import {
  CUSTOM_PROPOSAL_RADIO_OPTION_TEST_ID,
  FAVORITE_QUOTE_RADIO_OPTION_TEST_ID,
  INITIATE_PROPOSAL_EXPERIENCE_FORM_ID,
  SHELF_QUOTE_RADIO_OPTION_TEST_ID,
} from '../constants';
import { IMRadioGroupStyled } from './styles';
import QuoteExperienceOption from './QuoteExperienceOption';
import { TabIMFormStyled } from '../styles';

const EXPERIENCE_RADIO_CONFIG: Record<
  ProposalExperience,
  { label: string; id: string; key: string; 'data-test-id': string }
> = {
  SHELF: {
    label: 'Create a Shelf Proposal',
    id: 'shelf-proposal',
    key: 'shelf-proposal',
    'data-test-id': SHELF_QUOTE_RADIO_OPTION_TEST_ID,
  },
  FAVORITE: {
    label: 'Reuse a Favorite Proposal',
    id: 'favorite-proposal',
    key: 'favorite-proposal',
    'data-test-id': FAVORITE_QUOTE_RADIO_OPTION_TEST_ID,
  },
  CUSTOM: {
    label: 'Initiate a Custom Proposal',
    id: 'custom-proposal',
    key: 'custom-proposal',
    'data-test-id': CUSTOM_PROPOSAL_RADIO_OPTION_TEST_ID,
  },
};

interface Props {
  formController: FormController<{
    proposalExperience: FormControl<string>;
  }>;
  experiences: ProposalExperience[];
  formId?: string;
}

const QuoteExperienceStep: React.FC<Props> = observer(
  ({ formController, experiences, formId = INITIATE_PROPOSAL_EXPERIENCE_FORM_ID }) => {
    const radioButtons = experiences.map((experience) => ({
      ...EXPERIENCE_RADIO_CONFIG[experience],
      value: experience,
      label: <QuoteExperienceOption experience={experience} />,
    }));

    return (
      <TabIMFormStyled id={formId} formController={formController}>
        <SectionTitle title="Proposal Experience" subtitle="Select the proposal experience that best fits your needs" />
        <IMRadioGroupStyled name="proposalExperience" size="full" radioButtons={radioButtons} />
      </TabIMFormStyled>
    );
  },
);

export default QuoteExperienceStep;
